module.exports = require('@datadog/browser-rum');
